import { VendorConfigMap } from '@steelbuy/vendor';
import { Dashboard } from '../app/components/dashboard/Dashboard';
import { DashboardListings } from '../app/components/dashboard-listings.tsx/DashboardListings';
import { ListingSearchResults } from '../app/components/listing-search-results/ListingSearchResults';
import { SearchListings } from '../app/components/search-listings/SearchListings';

export const appVendorConfig: VendorConfigMap = {
    default: {
        components: { searchResults: ListingSearchResults, dashboard: Dashboard },
        features: {
            SELLER_SEARCH: true,
            SMART_MATCHING: true,
            DELIVERY_PROMISE: true,
            DYNAMIC_DELIVERY_PRICE: false,
            CLAIMS_POLICY: false,
        },
    },
    TNA: {
        components: {
            searchResults: SearchListings,
            dashboard: DashboardListings,
        },
        features: {
            SELLER_SEARCH: false,
            SMART_MATCHING: false,
            DELIVERY_PROMISE: false,
            DYNAMIC_DELIVERY_PRICE: true,
            CLAIMS_POLICY: true,
        },
    },
};
